module.exports = "<div class=\"oly-button\" ng-class=\"buttonClass\">\r\n    <div class=\"_oly-button-transclude\" ng-show=\"!loading.state\"></div>\r\n    <div ng-show=\"loading.state\" class=\"oly-button-loading _oly-button-loading\" ng-class=\"[btnClass, spinnerButtonClass]\" tabindex=\"0\">\r\n        <wow-loading-spinner custom-spinner-class=\"{{ childSpinnerClass }}\" ng-if=\"loading.state\" message=\"{{ loading.message }}\" class=\"{{ spinnerClass }}\"></wow-loading-spinner>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/button/button.directive.html
// module id = 742
// module chunks = 1